import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Results from "../views/Results.vue";
import { data } from "../data.js";

Vue.use(VueRouter);

import store from "../store";

console.log(store);

const routes = [
    {
        path: "/",
        component: Home,
    },
    {
        path: "/pathway/:level",
        name: "pathway",
        props: (route) => {
            // console.log(route);
            return {
                question: data.pathways.find(
                    (pathway) => pathway.key == route.params.level
                ),
            };
        },

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Path.vue"),
        beforeEnter: (to, from, next) => {
            //
            console.log(from);
            console.log({ store });
            if (from.path == "/" || store.state.prevStep) {
                next();
            } else {
                if (store.state.currentStep !== to.params.level) {
                    next("/");
                } else {
                    next();
                }
            }
        },
    },
    {
        path: "/results",
        name: "results",
        component: Results,
        beforeEnter: (to, from, next) => {
            if (store.state.results.length < 1) {
                next("/");
            } else {
                next();
            }
        },
    },
    {
        path: "*", // not found....
        beforeEnter: (to, from, next) => {
            next("/");
        },
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        return {
            x: 0,
            y: 0,
            behavior: 'smooth'
        };
    },
});

export default router;
